export { default as getDefaultSmartContract } from './getDefaultSmartContract';
